import React from "react";
import {Typography, Box, Modal} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import {COLOR} from "config/color";
import {ModalStyle} from "components/Styled";

const ExtraModalStyle = {
  background: COLOR.fontColorSecondary,
  "& .header": {
    display: "flex",
    "& svg": {color: COLOR.fontColorPrimary, marginLeft: "auto"},
  },
  "& .MuiTypography-body1": {
    fontSize: "1.4rem",
    lineHeight: "130%",
    letterSpacing: "1px",
    fontWeight: "normal",
    color: COLOR.fontColorPrimary,
    textAlign: "center",
  },
  "& .line": {
    background: COLOR.fontColorPrimary,
    height: "1px",
    width: "45px",
    margin: "15px auto",
    "&-top": {
      margin: "5px auto",
    },
  },
  "& .MuiTypography-body2": {
    color: COLOR.fontColorGray,
    fontSize: "1rem",
    fontWeight: "normal",
    lineHeight: "160%",
    letterSpacing: "1px",
    height: "70vh",
    overflow: "scroll",
  },
};

const PrivacyModal = ({open, setOpen}) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)} className="black-mask">
      <Box sx={{...ModalStyle, ...ExtraModalStyle}}>
        <div className="header">
          <CloseOutlinedIcon
            onClick={() => setOpen(false)}
            className="close_icon"
            color="primary"
          />
        </div>
        <div className="line line-top" />
        <Typography variant="body1" color="white">
          隱私權政策
        </Typography>
        <div className="line" />
        <Typography variant="body2" color="white">
          <div
            dangerouslySetInnerHTML={{
              __html: `
              <div class="popupScroll" ><div class="detail">
        隱私權政策<br>
        最後更新日：2023 年 8 月 <br>
        我們請您閱讀本政策，本政策說明以下第10節(資料控制者與聯絡人)中所列 La Prairie 集團之公司（下稱「La Prairie」或「我們」），如何蒐集、利用、揭露及處理您的個人資料。
    </div> <div class="detail"><h2>1. 簡介</h2></div> <div class="detail">
        本政策說明您可以如何存取及更新您的個人資料，並選擇個人資料的使用方式，而根據您的所在地點，您的選擇可能包括有權反對我們對個人資料進行的某些處理（包括個人化行銷），或者對於我們必須取得您同意的事項，有權撤回該同意。關於您的偏好選擇及權利的更多相關資訊，請參閱以下 第 8 節 。

本政策涵蓋我們的資料蒐集活動，包括我們透過各種線上管道（例如網站、應用程式及社群網路）及離線管道（例如銷售點、顧客服務及活動）所蒐集的個人資料。本政策亦說明我們如何在我們的網站及應用程式上使用 cookies 及相關技術蒐集資訊。根據您如何向我們提供您的個人資料，或您如何與 La Prairie 互動，部分章節可能對您不適用。請注意，為了提供給您符合您偏好及興趣的個人化服務，我們會把透過其中一種管道（例如 La Prairie 網站）所蒐集的個人資料，與另一種管道（例如 La Prairie 的銷售點或店內活動）所蒐集的個人資料相結合，而這種作法可能包括與原本由位於不同國家的不同 La Prairie 公司所蒐集的個人資料相結合。關於這些活動的更多相關資訊如下文所述。我們會告知您，您是否必須提供我們某些個人資料 - 如果您無法提供給我們該經要求的個人資料，我們可能無法為您提供所要求的產品或服務，或無法跟您進行通訊。

我們如果變更我們對您的個人資料的處理方式，我們會更新本政策，並通知您或依適當情況徵求您的同意，就此我們通常是在網站上公佈最新版本的政策。我們如作出大幅變更，導致我們就隱私權事項之做法產生重大改變者，我們可能亦會透過其他方式通知您，例如在變更生效前寄送電子郵件給您。我們有權隨時變更我們的做法及本政策。請您不定時前往我們網站，查閱本政策內容是否有任何更新或變更。

當我們蒐集個人資料時，如認為提供相關及適時的資訊會有所幫助者，我們亦可能向您提供額外資訊。

如果您在南韓使用我們的網站，請參閱本政策所附的南韓附錄。<br>
    </div> <div class="detail">
        <h2>2. 我們蒐集與處理哪些個人資料，以及我們如何蒐集？</h2>
        <div class="js-collapsible show-all content-page__section js-accordion-body" style="">
<p>我們透過各種線上與離線來源取得您的個人資料或是關於您的個人資料，包括當您從事下列活動時：(i) 與 <a href="http://www.laprairie.com">http://www.laprairie.com</a> 所列出的我們的網站、行動網站、應用程式、或社群媒體頁面（合稱為「數位平台」）互動；(ii) 在我們的數位平台上，或在我們的精品店、商店、櫃檯或水療中心（下稱「銷售點」）建立 La Prairie 帳戶；(iii) 在我們的聊天服務、論壇或部落格上與我們互動；(iv) 造訪我們其中一個銷售點；(v) 參加我們的活動及產品展示、忠誠度計畫或其他客戶計畫、競賽、推廣或問卷調查；(vi) 訂閱我們的行銷通訊；(vii) 在我們的數位平台或銷售點進行實體購物或線上購物；(viii) 參加我們的美容諮詢或療程；或 (ix) 與我們的美容顧問及客戶服務互動。</p>
<p>我們透過不同的授權商業夥伴銷售我們的產品。除非在您提供個人資料時另有說明，我們的授權商業夥伴獨立向您蒐集的任何個人資料，並不適用本政策。</p>
<p><i>我們會蒐集並處理以下的個人資料：</i></p>
<p>以下的清單概述我們可能會蒐集與處理的個人資料類別。不過，這些資料的蒐集與處理並非系統性的：我們僅蒐集並利用為滿足個別目的所需的個人資料。</p>
<p><i>您所提供的個人資料（例如在您建立 La Prairie 帳戶時、註冊我們的忠誠度計畫或其他客戶計畫時、或在我們的數位平台或銷售點向我們提供關於您的資料）：</i></p>
<ul class="second-level">
<li>聯絡資訊（例如您的姓名、住所和手機電話號碼、住家地址及電子郵件）；</li>
<li>身分識別資訊（例如您的年齡、生日、性別、國籍、居住國家、圖像、簽名）；</li>
<li>購物記錄以及跟我們互動的情形（例如訂單明細、購買的產品與數量、諮詢、療程、造訪我們的數位平台或銷售點）；</li>
<li>社群媒體帳戶；</li>
<li>帳單資料（包括運送地址與付款詳細資訊）。經我們合理地判斷認為有必要時，我們有權要求您提供帳單資訊的其他證據或證明。請注意，我們不會留存您支付款項之卡片的詳細資訊。我們透過第三方資料控制者處理付款詳細資訊；</li>
<li>網站註冊憑證（包括使用者名稱與密碼）。當您建立 La Prairie 帳戶，您可儲存並編輯您的運送地址與帳單資訊，以及檢視您先前的購物與訂購記錄；</li>
<li>偏好設定（例如通訊管道、偏好語言、產品偏好、護膚期望）；</li>
<li>個人生活資訊與推論（例如生活習慣、興趣、生活方式、嗜好、對行銷活動的反應）；</li>
<li>您參與我們的美容諮詢或療程時提供的皮膚類型與健康資訊（例如過敏、服藥情形、先前反應等），或者您向我們的客戶服務提供該等資訊；</li>
<li>關於您的外表特徵、護膚問題的資訊，及透過與我們不同的互動情形（例如美容諮詢或療程、問卷調查、或當您造訪我們社群媒體網頁、部落格或論壇，或是與客戶服務或聊天服務互動）所獲得的其他任何資訊；</li>
<li>我們與您之間的訊息往來與通訊；以及</li>
<li>您提供給我們的資訊或內容（例如照片、影片、評論、問題、問卷調查回覆及意見）。</li>
</ul>
<p>我們不會故意蒐集及處理未成年人的相關資料，我們也不會故意販售或分享在您的司法轄區被視為未成年人的個人資料。</p>
<p><i>由我們自動蒐集與處理的資訊，或因您使用數位平台、造訪我們的銷售點、或跟我們線上廣告互動時所自動蒐集與處理的資訊。</i></p>
<p>我們會自動蒐集並處理以下資料：</p>
<ul class="second-level">
<li>技術性的資料，包括您的裝置設備的 IP 位址、瀏覽器類型與版本、時區設定、瀏覽器外掛程式類型與版本、作業系統、唯一的裝置識別碼及廣告識別碼；</li>
<li>關於您造訪我們數位平台的相關資料，包括連接至、經過與來自我們數位平台的網址點擊流（包括其日期與時間）；您曾檢視或搜尋的產品，您檢視或與其互動的內容（及任何廣告）、網頁回應時間、下載錯誤、特定網頁的造訪時間長度、網頁互動資訊（例如捲動、點擊及滑鼠移動），及離開瀏覽網頁的方法。</li>
<li>線上活動，例如您的網際網路及其他電子網路活動資料，包括但不限於瀏覽記錄、搜尋記錄、以及您跟我們網站或第三方網站（例如社群媒體、應用程式或廣告）互動的相關資料，以及您所使用的服務供應商所分享之其他技術性資料或個人資料；</li>
<li>社群媒體資料 - 使用我們的數位平台通常不會涉及與第三方媒體平台及/或社群網路（例如：Facebook 或 Instagram）相關的資料處理作業。不過，如果您接受針對性的 cookies，或如果您透過那些平台使用分享按鈕分享我們的內容，則該第三方可能會蒐集並處理您的資料，以便為您提供個人化廣告。如欲深入瞭解上述第三方處理資料的方式以及您的資料保護權利，請參閱其各自的隱私權政策；</li>
<li>您造訪我們的精品店時的 CCTV 監控攝影機資料（例如：您的影相），基於安全因素，我們在精品店裝設 CCTV 監控攝影機，每週七天每天 24 小時對人員進行監視與錄影。當我們的精品店使用 CCTV 監控攝影機時，我們會確保在監控區域入口處有顯著標誌，以便告知員工、客戶及承包商，並且所有相關錄影內容在最多在 72 小時後會自動銷毀。我們的精品店內可能會進行其他活動，例如以彙整及匿名方式，測量及分析客戶的活動與人口統計資料。如果其中涉及處理您的個人資料，我們會在精品店提供額外和明確的通知，而且如相關法律要求取得同意者，我們會取得您同意；</li>
<li>關於為打擊仿冒及侵犯 La Prairie 智慧財產權所必要之資訊，例如身分識別與聯絡方式，以及與仿冒與侵權活動相關的其他任何資料與文件。這類資料可能由 La Prairie 直接蒐集，或是由La Prairie的供應商代表La Prairie蒐集，並由外部夥伴提供予 La Prairie；</li>
<li>關於為管理 La Prairie 的選擇性經銷系統所必要之資訊，以便保護 La Prairie 品牌並識別未經授權的經銷商。其中包括根據客觀標準(但不表示使用自動化決策)，剖析客戶購買行為的活動（例如購買的產品、數量、購買頻率及其他交易明細）。</li>
</ul>
<p>其中有些資訊是透過 cookies 及相關技術所蒐集。如欲深入瞭解，請參閱<a class="accordian" data-attr="section-6" data-toggle="collapse" href="#cookies">第 6 節</a>「Cookies 與相關技術」。</p>
<p><i>由第三方來源蒐集及處理的資料</i></p>
<ul class="second-level">
<li>我們會不定時地（在相關法律許可情況下）從受信任的第三方來源（例如商業與零售夥伴、付款與運送服務、社群媒體網路、廣告網路、分析供應商、市場研究組織、我們的關係企業、活動合作夥伴、政府機關及搜尋資訊供應商）蒐集您的偏好、興趣及其他人口統計資訊，例如當您同意該第三方向我們分享您的資料的情況。我們亦可能指示該第三方夥伴向外部平台提供其所擁有關於您的資料。該資料會用於本政策所述的目的，特別是用於豐富您的 La Prairie 個人檔案。該第三方處理您的個人資料時，適用該第三方的隱私權與 cookies 政策。</li>
<li>關於位置的資訊，當您造訪我們的數位平台，為了將您導引至適當的網域（網際網路位置）時，或當您要求我們提供位置服務時，例如尋找離您最近的門市或依據內容提供更更精準的位置。</li>
<li>當您就產品付款時，我們可能會收到付款處理服務供應商提供的資訊，該供應商會對您及您的支付方式進行信用及詐欺防制的查核，以利確認您的身分、驗證信用卡或簽帳卡、取得初始信用卡或簽帳卡授權、及/或授權個別購物請求。</li>
</ul>
<p><b>剖析</b></p>
<p>無論您在何處及如何與我們互動，為確保資料準確性並向您提供更好的個人化客戶體驗，我們會連結或結合從前述不同來源及管道所蒐集的資料，以便提供個人化服務、內容、針對性通訊與廣告，以及為分析的目的（例如我們會把您在我們數位平台的購物相關資料以及在銷售點所取得的資訊，例如因美容諮詢所取得的詳細資料相互結合，以便向您提供個人化服務、優惠及肌膚保養建議。） 此亦包括將不同 La Prairie 集團中之公司所蒐集之個人資料相互結合。La Prairie 所處理關於您的一切資料（包括由您提供或由我們或第三方蒐集的資料），均會連結至您的 La Prairie 個人檔案。我們亦可能會根據您的任何資料以及跟我們的互動情形進行推論，藉以豐富和補充個人檔案內容，進而反映您的偏好、特徵、趨勢、傾向、習性及態度。我們會使用您的身分識別資料（例如電子郵件地址或電話號碼），將該資料連結至您的個人檔案。上述情況亦適用於當您以訪客身分在我們數位平台上進行結帳，以及若您是潛在客戶的情況下。</p>
<p>您不需要向我們提供個人資料即可在銷售點購買我們產品或存取我們的數位平台，但您會無法使用部分功能與服務（例如透過網站購買我們的產品）。不過您可以選擇是否接收我們傳送的個人化行銷通訊，而我們只會在取得您的適當同意後，才會向您傳送該通訊。更多關於我們如何利用您的個人資料的相關權利與偏好的資訊，請參閱以下<a class="accordian" data-attr="section-8" data-toggle="collapse" href="#your-right">第 8 節</a>。</p>
<p>您不得將其他任何人的相關資料提供給我們，除非您已獲得該人的許可。</p>
</div>
         <div class="detail">
        <h2>3. 我們為何需要您的個人資料？</h2>
        我們將基於以下所列理由處理您的個人資料：<br>
<table style="width:100%">
<tbody>
<tr>
<th>目的</th>
<th>法律依據</th>
</tr>
<tr>
<td style="width:50%;"><b>為了向您提供您在我們的數位平台或銷售點已購買或要求的產品及服務。</b>其中包括處理您的付款、信用卡查核與詐欺防制作業、運送與退貨管理等。</td>
<td style="width:50%;"><ul><li>為了履行合約或採取與合約相關的步驟</li></ul></td>
</tr>
<tr>
<td><b>為了向您發送與服務相關的通訊。</b>其中包括與您的購買、美容諮詢、預約、或您已註冊的活動相關的通訊。</td>
<td><ul><li>為了履行合約或採取與合約相關的步驟</li></ul></td>
</tr>
<tr>
<td><b>為了設定並管理您的 La Prairie 個人檔案，並為您提供個人化服務。</b>我們會將處理的關於您的所有個人資料相互連結並合併，建立一份關於您的個人檔案，並依您的興趣與偏好進行調整，以提供個人化服務。更多詳細內容請參閱<a class="accordian" data-attr="section-2" data-toggle="collapse" href="#privacy-policy">第 2 節</a>「剖析」。</td>
<td><ul><li>為了履行合約或採取與合約相關的步驟</li>
<li>我們根據客戶的利益與偏好提供個人化服務以強化客戶忠誠度的合法利益。</li>
<li>您的同意（當地法律如要求取得同意者）</li></ul></td>
</tr>
<tr>
<td><b>經您同意後，基於行銷相關目的與您進行通訊。</b>其中包括依據您的通訊偏好，並在相關法律許可的範圍內，透過電話、貼文、簡訊、電子郵件、社群媒體、聊天或透過應用程式傳送關於我們產品、服務、促銷與活動的相關通訊，或寄送樣品、禮品和獎勵。這些通訊可由我們的美容顧問或我們集團中的任何公司進行（請參閱以下<a class="accordian" data-attr="section-8" data-toggle="collapse" href="#your-right">第 8 節</a>，瞭解如何控制您的偏好以及選擇不接收這類通訊）；</td>
<td><ul><li>您的同意</li></ul></td>
</tr>
<tr>
<td><b>為了讓您的 La Prairie 個人檔案內容更豐富。</b>其中包括透過使用我們或第三方（例如社群媒體 - 微信、WhatsApp、百度、Kakao Talk、Twitter、Facebook、Instagram 或其他線上平台）的 cookies 及類似技術，將您在社群媒體上的活動以及您在不同網站與裝置上的瀏覽活動等相關資訊，用於補充您的 La Prairie 個人檔案內容。該第三方使用您的個人資料之情形，適用其本身的隱私權與 cookie 政策。</td>
<td><ul><li>您的同意</li></ul></td>
</tr>
<tr>
<td><b>為了允許您參與網站的互動功能，以及依據以下<a class="accordian" data-attr="section-6" data-toggle="collapse" href="#cookies">第 6 節</a>內容，設置 cookies 及相關技術</b>。</td>
<td><ul><li>我們確保網站良好效能與使用者體驗的合法利益</li>
<li>您的同意</li></ul>
</td>
</tr>
<tr>
<td><b>為了徵詢您的意見或讓您參與市場調查或客戶研究；</b></td>
<td><ul><li>您的同意</li></ul></td>
</tr>
<tr>
<td>為了在我們的數位平台及其他特定合作夥伴網站上，<b>為您提供個人化廣告</b>。</td>
<td><ul><li>您的同意</li></ul></td>
</tr>
<tr>
<td><b> 為了建立類似受眾的行銷活動</b>，讓我們能接觸可能對我們產品感興趣的人，因為這些人與您有相似之處。我們可能使用 cookies 或其他可能仰賴第三方（例如 Facebook、Instagram、微信及其他線上平台）的技術。您可能已向該第三方表示同意，並且適用該第三方各自的隱私權政策。</td>
<td><ul><li>您的同意</li></ul></td>
</tr>
<tr>
<td><b>為了監控您的帳戶</b>，以便依據相關法律防範、調查及/或通報詐欺、恐怖主義、虛偽陳述、資料安全事故或犯罪情事。</td>
<td><ul><li>我們保護我們業務與系統的合法利益
</li>
<li>遵守法律義務 </li></ul></td>
</tr>
<tr>
<td><b>為了調查或回覆您或其他人就我們的數位平台、銷售點或我們的產品與服務所提出之申訴或問題。</b></td>
<td><ul><li>我們提供顧客服務、保護及改善業務的合法利益</li>
<li>遵守法律義務</li></ul> </td>
</tr>
<tr>
<td><b>為了監控我們數位平台與銷售點的使用情形</b>，並且使用您的資料協助我們監控、改善及保護我們的產品、品牌、內容、服務及數位平台和銷售點(包括線上及離線)，以及您對我們的體驗，包括透過研究與人口統計調查、分析與資料清理，以及衡量廣告活動的成效。</td>
<td><ul><li>我們分析、瞭解及改善業務活動的合法利益</li></ul> </td>
</tr>
<tr>
<td><b>為了於必要時將個人資料用於法律上的請求、法規遵循、監管及調查的目的</b>（包括在法律程序或訴訟中揭露該個人資料），或為執行或適用我們的<a href="https://www.laprairie.com/en-int/customer-care-privterms.html">使用條款</a>或其他任何協議、我們的選擇性的經銷系統、或為保護 La Prairie、我們的顧客或其他人的權利、財產或安全而使用個人資料。</td>
<td><ul><li>我們保護我們的公司與 La Prairie 品牌，以及捍衛自己免於受到法律求償的合法利益</li>
<li>遵守法律義務 </li></ul></td>
</tr>
<tr>
<td><b>基於我們內部企業通報的目的。</b></td>
<td><ul><li>我們的合法利益 </li></ul></td>
</tr>
<tr>
<td><b>為回應辦理調查的政府或執法主管機關的要求。</b></td>
<td><ul><li>遵守法律義務</li></ul></td>
</tr>
</tbody>
</table>
    </div> <div class="detail">
        <h2>4. 我們如何揭露與傳輸您的個人資料</h2>
        
除以下「資料控制者與聯絡人」一節所提到的 La Prairie 集團之公司外，我們可能基於前述目的，向下列第三方分享您的個人資料（在相關隱私權法律許可的前提下）：<br>

<div class="js-collapsible content-page__section section-4 js-accordion-body" id="disclose" style="">
<p>除以下「資料控制者與聯絡人」一節所提到的 La Prairie 集團之公司外，我們可能基於前述目的，向下列第三方分享您的個人資料（在相關隱私權法律許可的前提下）：</p>
<ul class="second-level">
<li>我們集團中的公司。您可在<a href="http://www.beiersdorf.com/about-us/beiersdorf-global#CH">這裡</a>查看我們集團公司的完整清單；</li>
<li>為處理交易的目的之銀行及我們的付款服務供應商；</li>
<li>（在取得您的許可後）第三方（例如社群網路供應商、禮賓服務，或我們的授權零售合作夥伴）。當您的個人資料與第三方分享時，該個人資料即適用該第三方的隱私權政策；</li>
<li>我們業務的可能或最終買家（若我們或我們大部分資產被第三方收購或與第三方合併，包括透過破產程序）；</li>
<li>經我們合理判斷認為，為遵守法律或監管義務，或執行或適用我們的<a href="https://www.laprairie.com/en-int/customer-care-privterms.html">使用條款</a>或其他任何協議及我們的選擇性經銷系統，或為保護 La Prairie、顧客或其他人的權利、品牌、財產或安全，而有必要分享的任何執法機關、法院、監管機關、政府主管機關或其他第三方。其中包括為了防範詐欺與減少信用風險等目的，而與其他公司和組織交換資訊；或</li>
<li>按照我們的指示，代表我們履行服務的第三方服務供應商（以及集團之公司及經授權的零售夥伴）。我們並未授權該第三方利用或揭露資訊，除非是代表我們履行服務或為遵守法律規定而有必要者。該第三方的例子包括在我們的授權零售商與合作夥伴在店內為您服務的員工、IT 支援服務供應商的員工、履行訂單與管理退款以及提供資料代管與支援、內容個人化、廣告及行銷服務（包括數位與個人化廣告）及資料清理、管理、區隔與分析的公司之員工。</li>
<p>請注意，前述第三方可能位於您居住國以外的國家，包括歐洲經濟區、英國或瑞士以外的國家。請點擊 <a href="https://www.laprairiegroup.ch/contact-us">此處</a>，查看我們的關係企業據點清單。當該第三方代表我們處理您的資料時，我們會與其實行適當的合約，其中包括嚴格的資料保護義務。關於國際資料傳輸的更多詳細資訊，請參閱以下的「資料傳輸」。</p>
</ul>
<p><i>我們亦會與第三方（包括社群媒體及搜尋引擎合作夥伴）分享資訊：</i></p>
<p>我們會將您的個人資料與其他顧客的資料彙整並建立一個關於我們平台的使用情形、產品購買情形及其他有關顧客的一般性或分類性資訊的資料集。雖然此資料集經過彙整及匿名化處理，表示無法利用資料直接或間接識別您的身分，但此資料集對於我們數位平台與銷售點的使用情形仍提供重要的深入分析，我們會與特定的第三方分享之。該第三方包括我們的集團公司。</p>
<p>我們亦會將與您有關的資料傳輸至廣告技術供應商及我們的社群媒體與搜尋引擎夥伴（包括 Meta、Google、TikTok 及 Twitter），使其能識別您的裝置，並且根據您的興趣提供相關內容與廣告。該資料可能包括您的姓名、郵寄住址、電子郵件、裝置 ID 或其他採用加密形式的識別碼。該供應商通常會以雜湊或去識別化的形式處理資料。該供應商可以向您蒐集其他資料，例如您的 IP 位址及有關瀏覽器或作業系統的資訊；在我們參與的資料分享合作中，將關於您的資料與來自其他公司的資料相互結合；並且可能在您的瀏覽器中放置或識別他們自己的專屬的 cookie。產生該 cookie 的第三方有其自已的隱私權政策，該政策將會適用。</p>
<p>就此，我們已經與 Meta 就共同控制權訂立相關協議，協議內容請參閱此處：<a href="https://www.facebook.com/legal/controller_addendum">https://www.facebook.com/legal/controller_addendum</a>。此協議針對共同控制權於相關法律下的義務履行事宜，定義個別責任。控制者與 Meta 資料保護官的詳細聯絡資訊，請查閱此處：<a href="https://www.facebook.com/about/privacy">https://www.facebook.com/about/privacy</a>。在不影響此約定的情況下，對資料當事人權利的管轄權不受限制。我們已經與 Meta 約定，Meta 可作為資料當事人行使權利事宜的聯絡窗口（請參閱<a class="accordian" data-attr="section-8" data-toggle="collapse" href="#your-right">第 8 節</a>）。</p>
<p>如欲瞭解 Meta 處理個人資料方式的詳細資訊，包括其法律依據以及資料當事人權利的相關資訊，請參閱此處、：<a href="https://www.facebook.com/about/privacy">https://www.facebook.com/about/privacy</a>。我們基於合法利益在共同控制權的範圍內傳輸資料。</p>
<p>資料安全性條件的相關資訊，請參閱此處：<a href="https://www.facebook.com/legal/terms/data_security_terms">https://www.facebook.com/legal/terms/data_security_terms </a>。關於制式化合約條款進行資料處理的相關資訊，請參閱此處： <a href="https://www.facebook.com/legal/EU_data_transfer_addendum">https://www.facebook.com/legal/EU_data_transfer_addendum</a>。</p>
<p><i>資料傳輸</i></p>
<p>您的個人資料主要儲存在位於歐盟的伺服器。但，由於我們的營運範圍遍及全球，因此可能會將您的個人資料傳輸至 La Prairie 集團內的其他公司（完整清單請查閱<a href="http://www.beiersdorf.com/about-us/beiersdorf-global#CH">此處</a>）、第三方服務供應商、或世界各地據點的授權零售夥伴，包括資料保護程度不足的國家。無論您是在我們的數位平台或是世界各地的銷售點與我們互動，及以何種方式與我們互動，我們希望您都能擁有最佳的服務與客戶體驗。因此我們可能必須將您的個人資料分享到您首次與我們分享您的個人資料時所在的國家以外的國家，惟該分享事宜完全是基於本政策所述的目的，而且只有當我們對於該第三方依相關法律所實施的資料保護與安全程度感到滿意時。為了讓我們能夠為您提供全球且個人化的客戶體驗和服務，我們必須分享您的個人資料。</p>
<p>如果您的個人資料被傳輸至您存取網站所在地點以外的司法轄區、歐盟或瑞士，以及依歐盟委員會、瑞士當局或相關法律規定未提供適當資料保護程度的司法轄區者，我們會透過簽署根據 GDPR 第 46 (2) 條規定的歐盟委員會與瑞士核准的制式化合約條款的方式，採取相關措施確保您的資料受到妥善保護，或根據相關法律實行其他措施，進而確保該傳輸獲得充分保護。來自歐盟與瑞士的使用者，若需要關於此主題的更多資訊，請參閱此處：<a href="https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection_en">https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection_en</a> </p>
<p>您可透過利用<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>所載的詳細聯絡方式，索取一份相關機制的副本以便審閱。</p>
</div>
    </div> <div class="detail">
        <h2>5. 我們會將您的個人資料保留多久？</h2>
        <div class="js-collapsible content-page__section section-5 js-accordion-body" id="howlong" style="">
<p>我們會根據以下的標準在特定期限內保留您的個人資料：(i) 執行本政策所載目的所需的時間；(ii) 任何相關的法律要求；或 (iii) 在相關情況下，您提出刪除的要求。</p>
<p>在相關法律許可的範圍內：</p>
<ul class="second-level">
<li>關於我們的客戶，我們會在合約關係期間內及合約結束後的七年內保存您的個人資料。</li>
<li>關於我們的潛在客戶：自您最後一次與我們互動後的三年期間內，我們會保存您的資料。</li>
</ul>
<p>請注意，我們可能必須遵照法律要求（例如稅務、會計或法律義務）將某些資料保存更長的時間。如需更多資訊，請利用<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>所載的聯絡方式與我們聯絡。</p>
</div>
    </div>
     <div class="detail">
        <h2>6. COOKIES 與相關技術</h2>
        <div class="js-collapsible content-page__section section-6 js-accordion-body" id="cookies" style="">
<p><u>什麼是 cookies？</u></p>
<p>Cookies 是一種由網站向您的電腦、行動裝置或其他聯網裝置傳送的小型文字檔案，可唯一識別您的瀏覽器或在瀏覽器中儲存資訊或設定。</p>
<p>在我們的平台、社群媒體頁面及通訊中，我們會使用，也允許第三方服務供應商使用 cookies、網路信標及其他類似技術。我們這麼做是為了瞭解您使用我們服務的情形、改善您的使用者體驗，以及提供個人化功能及內容；針對我們的廣告及行銷方式最佳化，並讓第三方廣告公司能夠協助我們在網際網路上提供符合您興趣的廣告。請前往 <a href="https://www.laprairie.com/en-int/privacy-policy.html?nogeoip=true">Cookie 設定</a>中檢視完整的 cookies 清單及更新您的偏好設定。</p>
<p><b>我們使用的 cookies 分類如下：</b></p>
<ul>
<li class="cookies_level1"><u>絕對必要的 cookies</u></li>
<p>這種 cookies 是網站運作所必要，無法在我們系統中關閉。通常只會在您做出相當於服務請求的動作時，才會設定這類的 cookies，例如設定您的隱私偏好、登入或填寫表格。您可以設定瀏覽器封鎖這種 cookies 或設定在這種 cookies 出現時提醒您，但若如此，網站的某些部分會無法運作。這種 cookies 不會儲存任何個人身分識別資料。</p></ul>
<ul>
<li class="cookies_level1"><u>分析型／效能型 的cookies</u></li>
<p>這種 cookies 讓我們能夠計算造訪次數與流量來源，以利衡量及改善我們網站的效能。這種 cookie 能幫助我們瞭解哪些頁面最受歡迎及最不受歡迎，並瞭解訪客在網站中的移動軌跡。在技術可行的情況下，這種 cookies 所蒐集的一切資料都會經過彙整，因此均屬匿名。<br>如果您不允許這種 Cookies，我們就無法知道您何時曾造訪我們網站。在取得您的同意後，我們使用 Google Inc 所經營的 Google Analytics 達成上述目的。如欲選擇退出 Google Analytics 的追蹤，您可以到<a href="https://www.laprairie.com/en-int/privacy-policy.html?nogeoip=true"> Cookie 設定</a>，或造訪 <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout。</a> </p></ul>
<ul>
<li class="cookies_level1"><u>功能型的 Cookies</u></li>
<p>這種 Cookies 能使網站能提供強化性的功能與個人化功能。這種 cookies 可能由我們或第三方供應商（我們已經將其服務新增至頁面）設置。如果您不允許這種 cookies，該服務可能有部分或全部無法正常運作。</p></ul>
<ul>
<li class="cookies_level1"><u>針對性／廣告性的 Cookies</u></li>
<p>這種 cookies 可能由我們的廣告合作夥伴透過我們的網站設置。該公司可能會使用這種 cookies 來建立您的興趣檔案，並在其他網站上向您顯示相關廣告。這種 cookies 不會儲存可直接識別個人身分的資料，而是置於能獨特地識別您的瀏覽器和網際網路裝置。如果您不允許這種 cookies，您會體驗到較少的針對性廣告。</p></ul>
<p><i>網站伺服器記錄檔與網路信標</i></p>
<p>在透過 cookies 取得資料的同時，我們的網站伺服器也可能會記錄資訊，例如作業系統類型、瀏覽器類型、網域及其他系統設定，以及您的系統使用的語言、裝置所在國家及時區等詳細資訊。網站伺服器記錄檔也可能會記錄資訊，例如將您連結至我們網站的網頁位址，以及您的網際網路連線裝置的 IP 位址等資訊。這種資訊能幫助我們對錯誤進行疑難排解、改善效能，及維護我們數位平台的資訊安全。為控制哪些網站伺服器能收集此類資訊，我們可能會在網頁上放置一種稱為「網路信標」的標籤。網路信標是一種把網頁連結至特定網站伺服器及其 cookies 的電腦指示。我們亦可能使用 cookies 及類似技術（例如網路信標），以便辨別我們向您發送之電子郵件是否已被開啟並已對其採取任何行動，以及我們的郵寄工具是否運作正常，或用於測量效能及向您提供相關性更高的內容與廣告。</p>
<p><i>我可以選擇不使用 cookies 及類似技術嗎？</i></p>
<p>您可以隨時在 <a href="https://www.laprairie.com/en-int/privacy-policy.html?nogeoip=true">Cookie 設定</a>中選擇接受或拒絕我們的 cookies。</p>
<p>當您拒絕接受或停用 cookies，您可能無法取得網站的某些內容或功能。</p>
<p>由於網路信標與網頁所含的其他內容請求相同，因此您無法選擇不使用或拒絕接受。不過，您可能藉由不下載所收到的電子郵件訊息中的圖片，進而停用訊息中所含的網路信標（這項功能取決於您個人電腦所使用的電子郵件軟體）。但，由於電子郵件軟體功能各有不同，所以這麼做並不一定能停用電子郵件訊息中的網路信標或其他類似技術。關於這方面的更多資訊，請參閱您電子郵件軟體或服務供應商所提供的資訊。如果您選擇不使用 cookies 或修改瀏覽器的 Cookie 設定，網路信標在某些情況下亦可能因此失效。</p>
</div>
<div class="detail">
<h2>7. 我們如何保護您個人資料的方式</h2>
我們致力於保護我們蒐集的個人資料，且保障您的個人資料的安全對我們相當重要。我們採取相關步驟，確保您的個人資料受到保護，免於受到未授權或非法的處理，並避免意外遺失、損壞、銷毀或揭露，而且我們將能存取您個人資料之人員限制在為了向您提供產品或服務而有合理必要存取您的個人資料之人。不過，沒有任何一種安全措施可以完全有效防止所有安全威脅。

我們的數位平台可能包含連接至第三方網站與來自第三方網站的連結。如果您透過連結進入任何這類網站，請注意這些網站有其各自的隱私權政策，而且對於這些政策或第三方對您個人資料的使用情形，我們概不負責。在您提交任何個人資料給這類網站之前，請務必先參閱其隱私權政策。

如果您在我們網站建立線上帳戶，作為我們安全程序的一部分，我們會要求您提供帳戶使用者名稱與密碼。您必須將該資料視為機密，不得向任何第三方揭露。
</div>
<div class="detail">
<h2>8. 您就您的個人資料有哪些權利與偏好？</h2>
<div class="js-collapsible content-page__section section-8 js-accordion-body" style="">
<p><b>您的權利</b></p>
<p>根據相關法律規定，您可能擁有以下權利：</p>
<ul class="second-level">
<li><b>資料查閱與取得權：</b>您有權以簡潔、透明、易懂且容易存取的方式被告知我們處理的與您有關的個人資料及我們如何處理這些資料。您亦有權利取得我們是否處理您的個人資料的確認，且如果我們確有處理您的個人資料，您有權存取該個人資料及取得一份副本。</li>
<li><b>更正權：</b>您有權更正自己的個人資料，且若資料不完整或不正確，亦有權使其完整。</li>
<li><b>刪除權：</b>您有權要求我們刪除您的個人資料。除非相關的資料保護法律另有規定，或 La Prairie 有保留個人資料的合法利益外，我們會刪除您的個人資料或把個人資料匿名化。</li>
<li><b>限制處理的權利</b>：在某些情況下，您有權限制您的個人資料的處理。</li>
<li><b>停止蒐集、利用及/或處理的權利：</b>如果您是台灣的居民，您有權利根據台灣的個人資料保護法，要求我們停止蒐集、利用及/或處理您的個人資料。</li>
<li><b>資料可攜權：</b>您有權以結構化、常用，且機器可讀取的格式接收您已提供給我們，且您有權把該個人資料傳輸給其他控制者。</li>
<li><b>撤回同意的權利：</b>如果您已同意資料處理，您可以在任何時候撤回該同意(如「您的偏好」所述)。請注意，撤回同意並不會影響撤回同意前已根據同意而處理資料的合法性。</li>
<p>在某些情況下，該權利可能會受到限制，例如當我們能顯示我們有處理您個人資料的法律要求或合約義務的情況。在某些情況下，這可能代表即便您撤回同意，我們還是能夠保留您的個人資料。在該情況下，我們將會採取適當的防護措施及保障，以保護您的個人資料安全。</p>
</ul>
<p><b>反對權</b></p>
<p>當您的個人資料係基於合法利益而處理時，您有權反對該處理。儘管如此，我們可能仍有合法的理由可繼續處理您的個人資料。</p>
<p>如果您欲行使上述任何權利，請透過<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>所載的詳細聯絡方式與我們聯絡。</p>
<p><b>您的偏好</b></p>
<p>我們會盡力為您提供關於您向我們提供個人資料的選擇。您可以透過下列機制控制您的個人資料：</p>
<p><b>廣告、行銷與個人化（離線與線上）：</b>如果您希望收到我們的產品與服務、活動、忠誠度計畫及其他客戶計畫相關通知，以及其他推廣活動通知，您可以透過我們的數位平台與銷售點上的相關勾選方塊，或透過答覆美容顧問或門市代表提出的問題，表明您的通訊偏好。我們的某些活動與通訊可能會按照您的特定興趣及偏好進行個人化處理（如法律要求須取得同意者，我們會會先取得您的同意）。</p>
<p>如果您希望停止收到我們的行銷通訊（及/或您只希望退出某些類型的個人化行銷通訊），您可以隨時按照相關通訊內容中的選擇退出的指示或利用<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>所載通訊方式通知我們。請注意，我們會傳送不同類型的個人化行銷通訊（例如電子報、美容顧問的電子郵件、問卷調查等），您可以選擇不要接收所有或部分通訊。選擇不要接收個人化行銷通訊，並不會停止收到我們的服務訊息（亦即非行銷類通訊，例如訂單狀態更新的電子郵件，或是帳戶活動的通知）。</p>
<p>請注意，我們可能會請您提供您就接收通訊內容的偏好通訊管道，您可以隨時透過聯絡我們的美容顧問，或利用<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>的聯絡方式來變更或更新這項偏好。</p>
<p>如相關法律要求須取得同意，我們僅會在取得您同意的情況下從事直接地行銷。如果您在我們的數位平台上有 La Prairie 帳戶，您可以在登入後，在帳戶個人檔案中撤回同意及/或更新您的通訊偏好設定。</p>
<p><b>Cookies/類似技術及興趣導向廣告：</b>您可以隨時在 <a href="https://www.laprairie.com/en-int/privacy-policy.html?nogeoip=true">Cookie 設定</a>中設定您的 Cookie 偏好。</p>
</div>
</div>
<div class="detail">
<h2>9. 美國隱私權揭露</h2>
<div class="js-collapsible content-page__section section-9 js-accordion-body" style="">
<p><i>如果您是加州居民，您可以利用下列隱私權：</i></p>
<ul class="second-level">
<li><b>知情權：</b>您有權知道我們蒐集哪些關於您的個人資料，包括個人資料的類別、蒐集個人資料的來源類別、蒐集、銷售或分享個人資料的業務目的或商業目的、我們揭露個人資料的第三方對象類別，以及我們所蒐集關於您的特定個人資料。</li>
<li><b>刪除權：</b>除特定例外情況外，您有權刪除我們已蒐集的您的個人資料。請注意，由於某些原因，我們會無法完全滿足您的要求，例如我們必要為您完成交易、偵測及防範詐欺與非法活動、行使我們的權利、符合公司內部目的、或遵守法律義務。</li>
<li><b>更正權：</b>對於我們可能保留的關於您的個人資料，如有任何不正確之處，您有權更正，惟必須經過適當驗證。</li>
<li><b>選擇不要出售或分享個人資料的權利：</b>您有權選擇拒絕將您的個人資料「出售」或「分享」（參照加州隱私權法律對這些名詞之定義）給第三方及非使用相同品牌名稱的關係企業。這表示如果您選擇退出，日後我們將不會出售您的個人資料或與這類第三方分享供其為其目的使用，其中包括跨情境行為廣告，除非您之後指示我們這麼做。</li>
<p>如果您是維吉尼亞州居民，您可以根據維吉尼亞州法典 59.1-577 條規定，享有若干隱私權。例如，您可以要求取得、更正、或刪除您的個人資料。由於我們「出售」個人資料且從事「針對性廣告」（請參照維吉尼亞州法律對這些名詞之定義），您也可以行使權利，選擇退出該出售行為或針對性廣告。您有權就您的隱私權被拒絕的情況提出申訴。</p></ul>
<p><i>如何提交請求 </i></p>
<p>若您要依據加州法律或維吉尼亞州法律行使您的知情權、刪除權或更正權，或針對您的隱私權被拒絕的情況提出申訴，請使用我們網站的<a href="https://www.laprairie.com/en-us/client-services">客戶服務</a>頁面，向我們傳送訊息或透過電話：1 800 821 5718，或使用下方「資料控制者與聯絡人」小節與我們聯絡。在我們回應您提出的取得與刪除請求前，我們可能會要求您提供若干資料以利驗證您的身分。我們會在 10 個工作日內確認收到您的請求，並且會在適當的驗證後 45 個日曆日內回覆您的請求，若我們需要更多時間，我們會再通知您。</p>
<p>若您要行使退出出售或分享個人資料的權利，請點擊位於我們網站頁尾的「<a href="https://www.laprairie.com/en-us/client-services">請勿出售或分享我的個人資料</a>」連結，或利用下方「資料控制者與聯絡人」一節與我們聯絡。</p>
<p>我們不會因您行使隱私權政策本節所述的權利而對您有差別待遇。</p>
<p><i>由代理人提出請求</i></p>
<p>您可以授權他人代表您（授權代理人）提出隱私權請求。授權代理人需要證明您已授權該人代您行事，或必須證明他們有符合相關遺囑公證法所訂之委託書。La Prairie 有權可以直接要求您確認該代理人確實經授權可提出請求，或要求提供額外資訊以確認該代理人的身分。授權代理人不得將消費者的個人資料或從消費者處蒐集的或關於消費者的任何資訊，用於其他非履行消費者的請求、驗證作業或預防詐欺的用途。</p>
<p><i>簡訊</i></p>
<p>您可以傳送簡訊「<b>SIGNUP</b>」到 48442 以接收 La Prairie 的獨家消息，或透過我們的網站註冊訂閱 La Prairie 傳送到您提供的手機號碼之促銷簡訊。購買任何商品或服務，並不需要以同意接收行銷簡訊作為條件。您的行動電話服務或無線裝置業者可能會就您收到的簡訊收取標準簡訊、數據、語音或其他費用。簡訊發送的頻率會有所不同。</p>
<p>您可以隨時對任何簡訊回覆「<b>STOP</b>」或傳訊至「48442」選擇不再接收簡訊。您可能會收到確認選擇退出請求的最終確認簡訊。如需協助相關簡訊，請對任何簡訊回覆「<b>HELP</b>」，或傳訊至「48442」。您也可以利用<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>所載聯絡方式與我們聯絡。</p>
<p>在美國支援的電信公司包括：AT&amp;T、Sprint、T-Mobile®、Verizon Wireless、Boost、Cricket、MetroPCS、U.S. Cellular、Virgin Mobile、ACS Wireless、Appalachian Wireless、Bluegrass Cellular、Carolina West Wireless、Cellcom、C-Spire Wireless （前身是 Cellsouth）、Cellular One of East Central Illinois、Cincinnati Bell Wireless、Cross (dba Sprocket)、Duet IP、Element Mobile、EpicTouch、GCI Communications、Golden State、Hawkeye (Chat Mobility)、Hawkeye (NW Missouri Cellular)、Illinois Valley Cellular、Immix (Keystone Wireless/PC Management)、Inland Cellular、iWireless、Mobi PCS (Coral Wireless LLC)、Mosaic、MTPCS/Cellular One (Cellone Nation)、Nex-Tech Wireless、nTelos、Panhandle Telecommunications、Peoples Wireless、Pioneer、Plateau、Revol Wireless、Rina - Custer、Rina - All West、Rina - Cambridge Telecom Coop、Rina - Eagle Valley Comm、Rina - Farmers Mutual Telephone Co、Rina - Nucla Nutria Telephone Co、Rina - Silver Star、Rina - South Central Comm、Rina - Syringa、Rina - UBET、Rina - Manti、South Canaan/CellularOne of NEPA、Thumb Cellular、Union Wireless、United、Viaero Wireless、West Central Wireless、Leaco、Nemont/Sagebrush。T-Mobile 對延遲或未傳送的訊息概不負責。</p>
<p><i>資料保護的揭露 </i></p>
<p><i>基於商業目的而揭露的個人資料類別</i></p>
<p>在過去 12 個月，La Prairie 基於商業目的（例如向我們的服務供應商或處理商揭露，其對我們所揭露個人資料的使用，僅限於根據書面合約向我們提供特定服務）已揭露以下類別的個人資料：</p>
<ul class="second-level">
<li><b>識別碼、帳單資訊及商業資訊</b>，向我們的關係企業、第三方服務供應商、付款處理商、電子郵件／簡訊服務供應商、客戶服務與情報平台、雲端資料儲存提供商，以及反詐欺與反仿冒服務供應商揭露。</li>
<li><b>網站註冊憑證</b>，向我們的雲端資料儲存供應商揭露。</li>
<li><b>偏好設定</b>，向我們的關係企業、第三方服務供應商、電子郵件／簡訊服務供應商、客戶服務與情報平台及雲端資料儲存供應商揭露。</li>
<li><b>個人生活資訊</b>，向我們的關係企業、第三方服務供應商、客戶服務與情報平台及雲端資料儲存供應商揭露。</li>
<li><b>與您的通訊</b>，向我們的關係企業、第三方服務供應商及雲端資料儲存供應商揭露。</li>
<li><b>您提供的內容</b>，向我們的關係企業、我們的第三方服務供應商及雲端資料儲存供應商揭露。</li>
<li><b>網際網路或電子活動資訊</b>，向我們的關係企業、第三方服務供應商、付款處理商、電子郵件／簡訊服務供應商、客戶服務與情報平台、雲端資料儲存提供商，以及反詐欺與反仿冒服務供應商揭露。</li>
<li><b>人口統計資訊</b>，向我們的關係企業、第三方服務供應商、付款處理商、電子郵件／簡訊服務供應商、客戶服務與情報平台、雲端資料儲存提供商，以及反詐欺與反仿冒服務供應商揭露。</li>
<li><b>敏感性個人資料</b>，向我們的關係企業、第三方服務供應商、電子郵件／簡訊服務供應商、客戶服務與情報平台及雲端資料儲存供應商揭露。</li>
<li><b>音訊或視訊資訊</b>，向我們的安全性供應商接露。</li>
<li><b>從上述類別資訊得出的推論</b>，向我們的關係企業、第三方服務供應商、付款處理商、電子郵件／簡訊服務供應商、客戶服務與情報平台、雲端資料儲存提供商，以及反詐欺與反仿冒服務供應商揭露。</li>
</ul>
<p>關於我們揭露個人資料之業務目的的其他詳細資訊，請參閱前文「我們如何揭露與傳輸您的個人資料」。</p>
<p><i>出售或分享的個人資料類別</i></p>
<p>在過去 12 個月，La Prairie 基於本隱私權政策所述目的，向廣告網路、廣告平台和社群媒體公司出售或分享以下類別的個人資料，其中包括針對性廣告：</p>
<ul class="second-level">
<li>識別碼 </li>
<li>商業資訊</li>
<li>偏好</li>
<li>個人生活資訊</li>
<li>網際網路或電子活動資訊</li>
<li>社群媒體資訊</li>
<li>人口統計資訊</li>
<li>從上述類別資訊得出的推論</li>
</ul>
<p>我們不會故意出售或分享未滿 16 歲人士的個人資料。</p>
</div>
</div>
<div class="detail">
<h2>10. 資料控制者與聯絡人</h2>
<div class="js-collapsible content-page__section section-10 js-accordion-body" id="data-controller" style="">
<p>如您對本政策或一般隱私事項有任何問題，或欲就我們遵循相關隱私權法律的情形提出申訴，請透過我們網站上的「<a href="https://www.laprairie.com/en-int/contact-us">聯絡我們</a>」頁面與我們聯絡，我們的顧客服務團隊將很樂意提供協助。</p>
<p>若要行使上述的偏好與權利，您也可以利用此「<a href="https://www.laprairie.com/en-int/contact-us">聯絡我們</a>」功能。<br>
我們會確認收到您提出的任何申訴並進行調查（包括關於我們違反您於相關隱私權法律中之權利的相關申訴）。我們希望能圓滿解決您的詢問。您可透過以下電子郵件地址聯繫La Prairie Group AG（及其關係企業）所指定的資料保護官 (DPO) ：<a href="mailto:Data.Privacy@LaPrairieGroup.ch">Data.Privacy@LaPrairieGroup.ch</a> </p>
<p>不過，您有權向相關資料保護主管機關提出申訴，特別是在您的慣住處所的會員國或涉嫌侵權的地點。</p>
<p>如果您位於澳洲，您的資料保護主管機關為澳洲資訊專員辦公室 (<a href="http://www.oaic.gov.au/">www.oaic.gov.au</a>)。</p>
<p>如果您位於香港，您的資料保護主管機關為香港個人資料私隱專員公署 (<a href="https://www.pcpd.org.hk/">https://www.pcpd.org.hk/</a>)</p>
<p>如果您位於日本，您的資料保護主管機關為日本個人情報保護委員會 (<a href="https://www.ppc.go.jp/">https://www.ppc.go.jp/</a>)。</p>
<div class="data-controller-country">
<h2>負責所有（線上及離線）活動的資料控制者</h2>
</div>
<div class="data-controller-country">
<p>&nbsp;</p>
<div class="country">LA PRAIRIE GROUP AG</div>
Industriestrasse 8<br>
CH-8604 Zurich-Volketswil<br>
<b>Switzerland</b><br>
電話號碼：+41 44 947 82 10<br>
「聯絡我們」表單：<a href="https://www.laprairie.com/en-int/contact-us">聯絡我們</a>
<p>&nbsp;</p>
<p><u>La Prairie Group AG（及其關係企業）的資料保護官：</u></p>
<p>電子郵件：<a href="mailto: Data.privacy@LaPrairieGroup.ch">Data.privacy@LaPrairieGroup.ch</a></p>
<p>電話：+41 44 947 82 10</p>
</div>
<div class="data-controller-country">
<p>&nbsp;</p>
<div class="country"><b>La Prairie Group AG 歐盟代表：</b></div>
電子郵件地址：&nbsp;<a href="mailto:office@datenschutz-sued.de">office@datenschutz-sued.de</a><br>
電話號碼：+49 931 304 976 0
<p>&nbsp;</p>
</div>
<div class="data-controller-country">
<p>&nbsp;</p>
<div class="country"><b>La Prairie Group AG 香港代表：</b></div>
電子郵件地址：<a href="mailto:Data.Privacy@LaPrairieGroup.ch">Data.Privacy@LaPrairieGroup.ch </a><br>
通訊地址：香港華蘭路 18 號 24 樓 2408-11 室
<p>&nbsp;</p>
<p>當您在我們銷售點購買 La Prairie 商品時或您向我們的店內美容顧問或代表人員提供詳細資料時，如有相關說明者，La Prairie 集團之公司亦會擔任當地資料控制者。請在此處查閱公司清單與詳細聯絡資訊：<a href="https://www.laprairiegroup.ch/contact-us">https://www.laprairiegroup.ch/contact-us</a>。</p>
</div>
</div>
</div>
<div class="detail">
<h2>南韓隱私權政策附錄</h2>
<div class="js-collapsible show-all content-page__section js-accordion-body" style="">
<p>本隱私權政策附錄（下稱「附錄」）僅在您於南韓使用本網站的情況方有適用。本附錄對本政策的資訊進行補充，並應與本政策一併閱讀。</p>
<p><b>個人資料處理與保留期間s</b></p>
<ul class="second-level">
<li>我們會在法律所要求或經您同意的保留期間內，處理並保留個人資料。</li>
<li>如<a class="accordian" data-attr="section-5" data-toggle="collapse" href="#howlong">第 5 節</a>所載，我們可能必須依照法律要求（例如稅務、會計或法律義務）將某些資料保留更長的時間。</li></ul>
<ul class="third-level"><li>如需更多資訊，請利用<a class="accordian" data-attr="section-10" data-toggle="collapse" href="#data-controller">第 10 節</a>所載聯絡方式與我們聯絡。</li>
</ul>
<p><b>蒐集及利用的個人資料項目</b></p>
<p>參照<a class="accordian" data-attr="section-2" data-toggle="collapse" href="#privacy-policy">第 2 節</a>所載資料類別，La Prairie蒐集並利用下列個人資訊項目，並區分為必要性資料與選擇性資訊：</p>
<ul class="second-level"><li>一般個人資訊</li></ul>
<table style="width:100%" border="solid">
<tbody><tr>
<th>平台</th>
<th>蒐集事件</th>
<th>資訊項目</th>
<th>必要性／選擇性</th>
</tr>
<tr>
<td rowspan="8" class="colcenter">
線上商店
</td>
<td rowspan="2" class="colcenter">
線上建立 La Prairie 帳戶
</td>
<td>
姓名、密碼、電子郵件地址、居住國、一般性同意
</td>
<td>
必要性
</td>
</tr>
<tr>
<td class="colcenter">
行銷同意、稱謂、生日、電話號碼、偏好語言、偏好通訊管道、原國籍／地區
</td>
<td>選擇性</td>
</tr>
<tr>
<td class="colcenter">
在我們的線上商店購買產品
</td>
<td class="colcenter">
信用卡資訊、銀行帳戶資訊、付款記錄、訂單記錄、地址、購買記錄
</td>
<td class="colcenter">
必要性
</td>
</tr>
<tr>
<td>
預訂線上諮詢
</td>
<td>
偏好語言、電話號碼
</td>
<td>
必要性
</td>
</tr>
<tr>
<td rowspan="2">
使用「聯絡我們」表單
</td>
<td>姓名、電子郵件地址
</td>
<td>
必要性
</td>
</tr>
<tr>
<td>
國家
</td>
<td>
選擇性
</td>
</tr>
<tr>
<td rowspan="2">
Cookie 資料
</td>
<td>IP 位址、造訪日期與時間、裝置資訊、時區設定、瀏覽器外掛程式類型與版本、作業系統、唯一裝置識別碼與廣告識別碼；連接至、經過及來自我們的數位平台的網址點擊流（包括其日期與時間）；您曾檢視或搜尋的產品；您曾檢視或與其互動的內容（或任何廣告）、網頁回應時間、下載錯誤，特定網頁的造訪時間長度、網頁互動資訊（例如捲動、點擊次數與滑鼠移動），以及離開瀏覽網頁的方法 </td>
<td>必要性</td>
</tr>
<tr>
<td>
社群媒體資料、地理定位
</td>
<td>
選擇性
</td>
</tr>
<tr>
<td rowspan="4" class="colcenter">
門市的離線作業
</td>
<td rowspan="2">
離線建立 La Prairie 帳戶
</td>
<td>
稱謂、姓名、電子郵件／手機、居住國、一般同意、簽名
</td>
<td>
必要性
</td>
</tr>
<tr>
<td>
行銷同意、生日、電子郵件／電話號碼（取決於上述未提供的管道而定）、偏好語言、原國籍／地區、個人生活資訊與推論、護膚期望
</td>
<td>
選擇性
</td>
</tr>
<tr><td rowspan="2">
諮詢／療程
</td>
<td>
姓名、電子郵件地址、簽名
</td>
<td>
必要性
</td>
</tr>
<tr>
<td>
地址、電話號碼、療程偏好
</td>
<td>
選擇性
</td>
</tr>
</tbody></table>
<ul class="second-level"><li>敏感性資訊</li></ul>
<ul class="third-level"><li>選擇性項目：在您參與我們的美容諮詢或療程的情況下，所取得的肌膚類型與醫療資訊（例如過敏、服藥情形、先前反應等）、關於您身體特徵的資訊、肌膚保養問題，以及透過跟我們不同互動方式取得的其他任何資訊。</li></ul>
<p><b>向第三方提供個人資料</b></p>
<p>我們在取得使用者同意的範圍內，會向以下所述的第三方提供個人資料。</p>
<p>1. 透過我們各種離線管道（例如銷售點、客戶服務及事件）收集的個人資料：</p>
<table style="width:100%" border="solid">
<tbody><tr>
<th>收受人</th>
<th>國家</th>
<th>目的</th>
<th>個人資料</th>
<th>保留期間</th>
</tr>
<tr>
<td>
La Prairie Group AG <br>
+41 44 947 82 10</td>
<td>
瑞士
</td>
<td>
履行合約、提供個人化客戶服務、統計數據與直接行銷（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>
基於以下標準的特定期間：(i) 實現目的之情形；(ii) 任何相關法律的要求；或 (iii) 您提出的任何刪除請求
</td>
</tr>
<tr>
<td>
位於南韓境外的 La Prairie Group AG 關係企業 </td>
<td>
請在此處查閱法人實體清單與詳細聯絡資訊：<a href="https://www.laprairiegroup.ch/contact-us">https://www.laprairiegroup.ch/contact-us</a>。
</td>
<td>
履行合約、提供個人化客戶服務、統計數據與直接行銷（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>
基於以下標準的特定期間：(i) 實現目的之情形；(ii) 任何相關法律的要求；或 (iii) 您提出的任何刪除請求
</td>
</tr>
</tbody></table>
<p>2. 透過我們各種線上管道（例如網站、應用程式和社群網路）蒐集的個人資料：</p>
<table style="width:100%" border="solid">
<tbody><tr>
<th>收受人</th>
<th>國家</th>
<th>目的</th>
<th>個人資料</th>
<th>保留期間</th>
</tr>
<tr>
<td> La Prairie Korea Ltd.<br>
+82263 90 11 11</td>
<td>
南韓
</td>
<td>
履行合約、提供個人化客戶服務、統計數據與直接行銷（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>
基於以下標準的特定期間：(i) 實現目的之情形；(ii) 任何相關法律的要求；或 (iii) 您提出的任何刪除請求
</td>
</tr>
<tr>
<td>
位於南韓境外的 La Prairie Group AG 關係企業 </td>
<td>
請在此處查閱法人實體清單與詳細聯絡資訊：<a href="https://www.laprairiegroup.ch/contact-us">https://www.laprairiegroup.ch/contact-us</a>。
</td>
<td>
履行合約、提供個人化客戶服務、統計數據與直接行銷（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>
基於以下標準的特定期間：(i) 實現目的之情形；(ii) 任何相關法律的要求；或 (iii) 您提出的任何刪除請求
</td>
</tr>
</tbody></table>
<ul><li>發生緊急事件，例如災難、傳染病、事故或意外等，導致生命或身體有迫切的危險以及立即發生財產損失時，本公司可依據政府機關共同公告之「緊急狀況個人資料處理與保護規則」辦理，不須取得資料當事人同意，即可向相關機關提供個人資料。請點擊此處（<a href="https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS217&amp;mCode=D010030000&amp;nttId=7641#LINK">連結</a> ），瞭解更多詳細內容。</li></ul>
<p><b>個人資料處理之委託</b></p>
<p>我們將個人資料的處理作業委託下述的第三方處理。</p>
<table style="width:100%" border="solid">
<tbody><tr>
<th colspan="5">個人資料處理之委託 </th>
</tr>
<tr>
<th>委託</th>
<th>國家</th>
<th>委託的工作範圍</th>
<th>個人資料</th>
<th>保留期間</th>
</tr>
<tr>
<td>
ARIM Mailing Packaging Co. Ltd.<br>
+82 2 803 2445
</td>
<td>
南韓
</td>
<td>
直接郵遞方式發送 La Prairie 行銷通訊（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏及地址
</td>
<td>
傳送日期起算一個月後
</td>
</tr>
<tr>
<td>
Invito <br>
+82 70 5143 6862
</td><td>
南韓
</td>
<td>
透過文字簡訊及 SMS 簡訊發送 La Prairie 行銷通訊（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏及電話號碼
</td>
<td>
於傳送日期起一個星期後
</td>
</tr>
<tr>
<td>Wee’s Group <br>
+82 70 5038 3023
</td>
<td>
南韓
</td>
<td>
透過行動 DM／網站系統開發方式發送 La Prairie 行銷通訊（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏及電話號碼、交易記錄、個人偏好
</td>
<td>
於要求維護日期起一個星期後
</td>
</tr>
<tr>
<td>Schenker Korea Ltd.<br>
+82 32 744 0300
</td>
<td>
南韓
</td>
<td>
將包裹傳送給我們電子商務平台的顧客
</td>
<td>
名字、姓氏及電話號碼、地址
</td>
<td>
直到合約終止
</td>
</tr>
<tr>
<td>SureM<br>
+82-70-4162-4744
</td>
<td>
南韓
</td>
<td>
透過手機與 Kakao 方式發送 La Prairie 行銷通訊（僅在您已同意接收行銷通訊者才會收到）
</td>
<td>
稱謂、名字、姓氏、電話號碼及國籍
</td>
<td>
保留至發送當月的下一個月
</td>
</tr>
<tr>
<td>Ilyang Logis<br>
+82 1588 0002
</td>
<td>
南韓
</td>
<td>
包裹快遞追蹤
</td>
<td>
名字、姓氏及電話號碼、地址
</td>
<td>
發送日期起算三個月後
</td>
</tr>
</tbody></table>
<p><b>個人資料的跨國傳輸</b></p>
<p>我們於國外委託他人處理個人資料如下：</p>
<ol><li>透過我們各種<b>離線</b>管道（例如銷售點、客戶服務及事件）蒐集的個人資料：</li>
<table style="width:100%" border="solid">
<tbody>
<tr>
<th>服務供應商</th>
<th>司法轄區</th>
<th>目的</th>
<th>個人資料</th>
<th>保留期間</th>
</tr>
<tr>
<td>
Winparf SAS <br>
+33 1 80 05 13 40
</td>
<td>
法國
</td>
<td>
資料庫維護
</td>
<td>
稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>
直至 La Prairie 客戶帳戶刪除為止
</td>
</tr>
<tr>
<td>
BnKay Limited <br>
+852 9664 3319
</td><td>香港
</td>
<td>資料庫維護
</td>
<td>稱謂、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>直至 La Prairie 客戶帳戶刪除為止
</td>
</tr>
<tr>
<td>Free FutureSoft Ltd.<br>
+30 210 9249704
</td>
<td>希臘
</td>
<td>資料庫維護
</td>
<td>稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言、交易記錄、個人偏好
</td>
<td>直至 La Prairie 客戶帳戶刪除為止
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<li>透過我們各種<b>線上</b>管道（例如網站、應用程式和社群網路）蒐集的個人資料：</li>
<table style="width:100%" border="solid">
<tbody>
<tr>
<th>服務供應商</th>
<th>國家</th>
<th>目的</th>
<th>個人資料</th>
<th>保留期間</th>
</tr>
<tr>
<td>
Salesforce.com Inc.<br>
<a href="tel:1-800-667-6389">1-800-667-6389</a>
</td>
<td>
美國
</td>
<td>
住宅服務
</td>
<td>
稱謂、名字、姓氏、地址、電子郵件、電話號碼、生日、國籍、偏好語言
</td>
<td>
直至 La Prairie 線上客戶帳戶刪除為止
</td>
</tr>
</tbody></table>
</ol>
<p><b>個人資料之銷毀</b></p>
<ul class="second level"><li>當個人資料已成為非必要時，例如保留期間已滿，或處理個人資料的目的已達成時，我們會立即銷毀該個人資料。當我們收到刪除個人資料的請求時亦同樣適用。</li>
<li>我們會按以下方式銷毀個人資料：</li></ul>
<ul class="third level"><li>銷毀程序：基於上述任何原因蒐集的資料，會在目的達成後標示為應銷毀，然後予以銷毀。</li>
<li>銷毀方式：對於以電子檔方式記錄與儲存的個人資料，我們會以不可回復的方式予以銷毀，對於以紙本方式記錄與儲存的個人資料，我們會將之絞碎或燒毀。</li>
</ul>
<p><b>確保個人資料安全的措施 </b></p>
<ul class="second level"><li>我們會採取以下措施，確保個人資料的安全。</li></ul>
<ul class="third level"><li>行政性措施：內部管理計畫的建立與運作、定期員工訓練、合理使用政策、事件管理計畫、保密協議、密碼政策、滲透測試、安全處置方法。</li>
<li>技術性措施：個人資料處理系統存取權限的管理（包括視需要變更及取消存取權限）、存取控制系統的安裝、對個人資訊的加密，以及安全程式的安裝與更新、定期軟體更新排程、反惡意軟體、防火牆、多因素驗證。</li>
<li>實體措施：對電腦室、資料儲存室及整個場所實施門禁限制。</li></ul>
<p><b>行為資訊蒐集與使用相關事宜及拒絕</b></p>
<ul class="second level"><li>我們透過 cookies 蒐集並利用行為資訊，以提供客製化服務與福利，並在您使用服務期間提供為您最佳化的客製化線上廣告。<br>
我們允許客製化線上廣告公司透過 cookies 蒐集及處理行為資訊。</li>
<li>如欲查閱蒐集上述資訊類別的所有 cookies 完整清單，請造訪我們<a href="https://www.laprairie.com/ko-kr/privacy-policy.html?nogeoip=true">位於此處</a>的隱私權偏好中心，然後在行銷 cookie 標題底下點擊「Cookie 詳細資料」。您也可以在這裡查閱各種 cookie 類型的各別保留期間。</li></ul>
<ul class="third level"><li>行為資訊蒐集方法：在使用者造訪我們數位平台時自動蒐集與傳輸</li>
<li>蒐集與處理的行為資訊項目：關於您造訪我們數位平台的資訊（包括連接至、經過與來自我們數位平台的網址點擊流（包括日期和時間）；您曾檢視或搜尋的產品；您檢視或互動的內容（以及任何廣告）、網頁回應時間、下載錯誤、特定網頁的造訪時間長度、網頁互動資料（例如捲動、點擊與滑鼠移動），以及瀏覽時離開網頁的方法）、線上活動（例如您的網際網路及其他電子網路活動資訊，包括但不限於瀏覽記錄、搜尋記錄以及您跟我們網站或第三方網站（例如社群媒體、應用程式或廣告）互動的相關資訊，以及您所使用服務供應商所分享之其他技術資訊或個人資訊；技術資訊（包括您裝置的 IP 位址、瀏覽器類型與版本、時區設定、瀏覽器外掛程式類型與版本、作業系統、唯一裝置識別碼及廣告識別碼）；社群媒體資料（使用我們的數位平台，通常不會涉及跟第三方媒體平台及／或社群網路（例如：Facebook 或 Instagram）相關的資料處理。不過如果您接受針對性 cookie，或如果您透過該平台使用分享按鈕分享我們的內容，該第三方可能會蒐集並處理您的資料，以便為您提供個人化廣告。如欲深入瞭解該等第三方處理您的資料的方式以及您的資料保護權利，請參閱其各自的隱私權政策）。</li></ul>
<ul class="second level"><li>我們 (i) 僅蒐集線上客製化廣告所需的最少量行為資訊，並且 (ii) 不會蒐集任何可能嚴重侵犯個人權利、利益或隱私權的敏感性行為資訊，例如意識形態、信仰、家庭關係與親戚、教育背景、病史及其他社交活動。</li>
<li>您可以使用「聯絡」一節所列出的聯絡資訊提出行為資訊的相關問題，例如行使您的拒絕權、接收損害報告等。</li></ul>
<p><b>其他利用與提供</b></p>
<ul class="second level"><li>我們在考量以下事項後，可能會在未經使用者同意情況下，另外利用或提供您的個人資料：</li></ul>
<ul class="third level"><li>個人資料的其他利用或提供，是否與原蒐集目的相關；</li>
<li>就個人資料蒐集情況或個人資料處理實務，個人資料的其他利用或提供是否是可預見；</li>
<li>個人資料的其他利用或提供，是否會不當侵害使用者的利益；以及 </li>
<li>是否已經採取必要措施確保安全性，例如擬匿名化或加密。</li></ul>
<p><b>聯絡</b></p>
<ul class="second level"><li>如果您對隱私權政策有任何疑問或意見、需要通報問題，或如果您希望我們更新、修改或要求刪除我們所持有關於您的資料，請聯絡我們的隱私長 (CPO)（或負責個人資料保護的部門）：</li>
<li>隱私長與負責部門</li></ul>
<ul class="third level"><li>負責部門（負責受理與處理個人資料存取請求等）：La Prairie Group AG 法律與法規遵循 </li>
<li>電話（直撥）：+41 44 947 82 10</li>
<li>電子郵件：<a href="mailto:Data.Privacy@LaPrairieGroup.ch">Data.Privacy@LaPrairieGroup.ch</a> </li></ul>
<p><b>權利侵害的救濟</b></p>
<ul class="second level"><li>您可以提出爭議解決的申請，及諮詢韓國個人資料爭議調解委員會、韓國網際網路安全局的個人資料侵權通報中心及其他機構，以尋求個人資料侵害事宜的救濟。對於其他任何個人資料侵權情事的通報與諮詢事宜，請聯絡以下機構。</li></ul>
<ul class="third level"><li>韓國個人資料爭議調解委員會：1833-6972（無需區碼；www.kopico.go.kr）</li>
<li>韓國個人資料侵權通報中心：118（無需區碼；privacy.kisa.or.kr）</li>
<li>韓國大檢察廳：1301（無需區碼；www.spo.go.kr） </li>
<li>韓國國家警察局：182（無需區碼；ecrm.cyber.go.kr） </li></ul>
<ul class="second level"><li>如果您認為自己的隱私權與利益因政府機關主管之作為或不作為而受到侵害，可依據行政上訴法提出行政上訴，並請聯絡下列機構。</li></ul>
<ul class="third level"><li>韓國中央行政上訴委員會：110（無需區碼；www.simpan.go.kr） </li></ul>
<ul class="second level"><li>我們會確保您的隱私權，並盡力為個人資料侵權情事提供相關諮詢及／或救濟。如果您希望就任何個人資料侵權情事取得相關諮詢或報告，請利用上述「聯絡」小節所列聯絡資訊，跟我們的隱私長 (CPO)（或負責個人資料保護的部門）聯絡。</li></ul>
<p><b>本政策的先前版本：</b></p>
<ul class="second level"><li>如需參閱本隱私權政策的先前版本，請參閱下文。</li></ul>
<ul class="third level"><li>適用期間：西元2019 年 11 月 1 日至西元2023 年 6 月 26 日 （<a href="https://laprairie.com/en-int/pp-kr-2019">點擊</a>）</li></ul>
</div>
</div>
        </div>`,
            }}
          ></div>
        </Typography>
      </Box>
    </Modal>
  );
};

export default PrivacyModal;
